import {BasicDataTable, BasicDataTableConfig, TypedColumnSettings} from "@/shared/ui/basicDataTable";
import {RequestParam} from "@/shared/api";
import {SecurityStatus} from "@/shared/securityStatus";
import {AbstractWorkingTimeRequestResponseModel} from "@/shared/timr";
import {WorkingTimeRequestStatus} from "@/shared/timrTypes";
import {WorkingTimeRequestUtil} from "@/shared/workingtime/workingTimeRequestUtil";

export class WorkingTimeRequestRevisionsTable extends BasicDataTable<AbstractWorkingTimeRequestResponseModel> {

	private static COLUMN_DATE = "160px";

	constructor(public config: BasicDataTableConfig) {
		super("/timr/requests/findWorkingTimeRequestRevisions.json", config);
	}

	public static buildFilterParams(workingTimeRequestId: number): RequestParam[] {
		return [{
			name: "workingTimeRequestId",
			value: workingTimeRequestId
		}];
	}

	public filterByWorkingTimeRequestId(workingTimeRequestId: number): JQueryPromise<AbstractWorkingTimeRequestResponseModel[]> {
		return this.filter(WorkingTimeRequestRevisionsTable.buildFilterParams(workingTimeRequestId));
	}

	protected getColumnSettings(): TypedColumnSettings<AbstractWorkingTimeRequestResponseModel>[] {
		const columns: TypedColumnSettings<AbstractWorkingTimeRequestResponseModel>[] = [];
		columns.push({
			data: "lastModified",
			orderable: this.config.orderable,
			render: BasicDataTable.renderDateTimeLocal,
			visible: true,
			width: WorkingTimeRequestRevisionsTable.COLUMN_DATE
		});
		columns.push({data: "modifiedByUser", orderable: this.config.orderable, render: BasicDataTable.renderUser});
		columns.push({data: "start", orderable: false, render: this.renderDateRange});
		if (SecurityStatus.isSubstitutesAllowed()) {
			// substitute only exists on WorkingTimeDateSpanRequestResponseModel
			// is blank if not available
			columns.push({data: "substitute", orderable: this.config.orderable, render: BasicDataTable.renderUser} as TypedColumnSettings<AbstractWorkingTimeRequestResponseModel>);
		}
		columns.push({data: "status", orderable: false, render: this.renderStatus});
		columns.push({
			data: "statusComment",
			className: "table-data-description",
			orderable: this.config.orderable,
			render: BasicDataTable.renderDescriptionText
		});
		return columns;
	}

	protected renderStatus(this: void, data: WorkingTimeRequestStatus, _type: string, workingTimeRequest: AbstractWorkingTimeRequestResponseModel, _meta: DataTables.CellMetaSettings) {
		return data ? `<span class="label request-status-${data} request-category-${workingTimeRequest.workingTimeType.category}"><span>${messages["workingTimeRequestStatus." + data]}</span></span>` : "";
	}

	protected renderDateRange(this: void, _data: string, _type: string, workingTimeRequest: AbstractWorkingTimeRequestResponseModel, _meta: DataTables.CellMetaSettings) {
		return WorkingTimeRequestUtil.renderDateRange(workingTimeRequest);
	}

	protected getDefaultOrder(): (string | number)[][] {
		return [[0, "asc"]];
	}

	protected createDataTableConfig(): DataTables.Settings {
		return {
			pageLength: 4,
			deferLoading: 0,
			dom: `rt`
		};
	}
}
